import React from 'react'
import BaseComponent from "../pages/base/BaseComponent";
import {Button, Card, Col, Modal, Row} from "@themesberg/react-bootstrap";
import label from "enqc-utilities/src/label/Label"
import PropTypes from 'prop-types';
import ApplicationIcons from "enqc-utilities/src/misc/ApplicationIcons";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faEye, faToggleOff} from "@fortawesome/free-solid-svg-icons";
import {navigate} from "enqc-utilities/src/utils/Utilities";
import UserDetailPage from "../pages/management/UserDetailPage";

export default class UserDetailInformationModal extends BaseComponent{

    componentWillReceiveProps(nextProps, nextContext) {
        if(nextProps!=this.props){
            let {show} = nextProps
            this.setState({show},() => {
                if(show){
                    // window.history.pushState({ show: true }, '');
                    this.handlePopState = (event) =>{
                        if (show) {
                            this.props.onClose()
                            // window.history.pushState(null, ''); // re-push state to prevent deep back
                            window.history.pushState({ show: true }, '');
                        }
                    }
                    window.addEventListener('popstate', this.handlePopState);
                }else{
                    window.removeEventListener('popstate', this.handlePopState);
                }
            })
        }
    }

    render() {
        let {user,show} = this.props
        let {manufacturingSite} = user
        if(!manufacturingSite){
            manufacturingSite= {}
        }

        return (
            <>
                {super.render()}
                <Modal as={Modal.Dialog} size="sm" centered show={show} onHide={()=>{}}>
                    <Modal.Body className="text-center">
                        <Row>
                            <Col>
                                <Row>
                                    <Col>
                                        <Card border="light" className="text-center p-0 mb-0">
                                            <div className="profile-cover rounded-top bg-light" />
                                            <Card.Body className="pb-4">
                                                <Card.Img src={user.photoUrl?user.photoUrl:ApplicationIcons.Icons.userAvatar} alt={user.fullname}
                                                          className="bg-white border-secondary user-avatar large-avatar rounded-circle mx-auto mt-n7 mb-4" />
                                                <Card.Subtitle>{user.fullname}</Card.Subtitle>
                                                <Card.Text className="text-gray">{user.email} / {manufacturingSite.name}</Card.Text>
                                            </Card.Body>
                                        </Card>
                                    </Col>
                                </Row>
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <Button
                                    className="w-100 d-block"
                                    variant="success"
                                    onClick={()=>{
                                    this.props.onClose()
                                }}>
                                    <FontAwesomeIcon icon={faToggleOff} size="sm" />
                                    &nbsp;
                                    {label.Close}
                                </Button>
                            </Col>
                        </Row>
                        <br/>
                        <Row>
                            <Col>
                                <Button
                                    className="w-100 d-block"
                                    variant="info"
                                    onClick={()=>{
                                        this.props.onClose()
                                        navigate(this.props, UserDetailPage.ENDPOINT+"/"+user.userCode)
                                    }}>
                                    <FontAwesomeIcon icon={faEye} size="sm" />
                                    &nbsp;
                                    {label.Detail}
                                </Button>
                            </Col>
                        </Row>
                    </Modal.Body>
                </Modal>
            </>
        );
    }

}
UserDetailInformationModal.propTypes = {
    user:PropTypes.object.isRequired,
    show:PropTypes.bool.isRequired,
    onClose:PropTypes.func.isRequired

}
